import { useSessionStore } from "@/plugins/store/session";
import { useCheckoutStore } from "@/plugins/store/checkout";
import { usePaymentsStore } from "@/plugins/store/payments";
import { useLloydsStore } from "@/plugins/store/providers/lloyds";
import { useAdyenStore } from "@/plugins/store/providers/adyen";
import { useIFXStore } from "../providers/ifx";

/**
 * Composable to clear session data across multiple stores.
 * This is useful when the user logs out or when starting a new payment session,
 * ensuring that all relevant data is reset to prevent any unintended data
 * persistence.
 */
export function useSessionClear() {
    const sessionStore = useSessionStore();
    const checkoutStore = useCheckoutStore();
    const paymentsStore = usePaymentsStore();
    const lloydsStore = useLloydsStore();
    const adyenStore = useAdyenStore();
    const ifxStore = useIFXStore();

    function clearSessionData() {
        sessionStore.setSessionId();
        sessionStore.setUser(null);
        sessionStore.setEmailAddress(null);
        checkoutStore.setSupplementaryData(null);
        checkoutStore.setPayerDetails(null);
        paymentsStore.setPaymentId(null);
        paymentsStore.setPaymentMethods(null);
        paymentsStore.setSelectedProvider(null);
        paymentsStore.setSelectedProviderDetails(null);
        checkoutStore.setTriggerPayerInformationValidation(false);
        checkoutStore.setTriggerCardInformationValidation(false);
        checkoutStore.setPartnerLinkInformation(null);
        lloydsStore.setLloyds3DSMethodData(null);
        lloydsStore.setLloydsChallengeData(null);
        lloydsStore.setLloyds3DSMethodDataConsumed(false);
        lloydsStore.setLloydsChallengeDataConsumed(false);
        adyenStore.setTokenisationStatus(null);
        ifxStore.setIFXBankTransferInformation(null);
        ifxStore.setIFXPaymentInformation(null);
    }

    function clearSessionDataForAnotherPayment() {
        checkoutStore.setTriggerPayerInformationValidation(false);
        checkoutStore.setTriggerCardInformationValidation(false);
        lloydsStore.setLloyds3DSMethodData(null);
        lloydsStore.setLloydsChallengeData(null);
        lloydsStore.setLloyds3DSMethodDataConsumed(false);
        lloydsStore.setLloydsChallengeDataConsumed(false);
        adyenStore.setTokenisationStatus(null);
    }

    return {
        clearSessionData,
        clearSessionDataForAnotherPayment,
    };
}
